export default {"src":"/_next/static/media/contract-blank-right.a754e54f.svg","height":235,"width":171,"blurWidth":0,"blurHeight":0};